/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../map-command.class';
import { ZoomLatLonDialogComponent } from './zoom-lat-lon-dialog.component';

export class ZoomLatLonCommand extends MapCommand {

    invoke() {
        const dialog = this.deps['dialog'];
        const zoomLatLonService = this.deps['zoomLatLonService'];
        dialog.open(ZoomLatLonDialogComponent, {
            autoFocus: true,
            hasBackdrop: false,
            position: {top: '128px'},
            panelClass: 'zoom-lat-lon-container',
        }).afterClosed().subscribe(() => {
            zoomLatLonService.clearFeatures();
            this.deactivate$.next();
        });
    }
}
